<template>
  <div id="footerArea">
    <footer class="pc_footer">
      <p>Copyright © Lawson, Inc. All Rights Reserved.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: "FooterItem"
};
</script>

<style>
</style>